import { render, staticRenderFns } from "./PacientesDetalleOdontogramasInfantiles.vue?vue&type=template&id=4eae0c21"
import script from "./PacientesDetalleOdontogramasInfantiles.vue?vue&type=script&lang=js"
export * from "./PacientesDetalleOdontogramasInfantiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports